/**
 * @param {string} status work status value
 * @return {object} badge config with label and className
 */
export const getWorkStatusBadge = (
  status: string,
): { label: string; className: string } => {
  switch (status) {
    case "working":
      return { label: "稼働中", className: "badge-info" };
    case "ending_soon":
      return { label: "もうすぐ空き", className: "badge-warning" };
    case "available":
    default:
      return { label: "空き", className: "badge-ghost" };
  }
};

/**
 * @param {string} affiliation affiliation value
 * @return {string} display label
 */
export const getAffiliationLabel = (affiliation: string): string => {
  switch (affiliation) {
    case "proprietary":
      return "自社";
    case "partner":
      return "パートナー";
    default:
      return affiliation;
  }
};

/**
 * @param {string} type employment type value
 * @return {string} display label
 */
export const getEmploymentTypeLabel = (type: string): string => {
  switch (type) {
    case "full_time":
      return "正社員";
    case "freelancer":
      return "フリーランス";
    case "contract":
      return "契約社員";
    default:
      return type;
  }
};

/**
 * @param {string} pref remote preference value
 * @return {string} display label
 */
export const getRemotePreferenceLabel = (
  pref: string | null | undefined,
): string => {
  switch (pref) {
    case "full_remote":
      return "フルリモート";
    case "hybrid":
      return "ハイブリッド";
    case "onsite_only":
      return "出社";
    default:
      return "-";
  }
};

/**
 * @param {string} stage pipeline stage value
 * @return {string} stage badge CSS class
 */
export const getStageBadgeClass = (stage: string): string => {
  switch (stage) {
    case "preparation":
      return "badge-ghost";
    case "proposed":
      return "badge-info";
    case "doc_screening":
      return "badge-primary";
    case "interview":
      return "badge-secondary";
    case "offer":
      return "badge-accent";
    case "won":
      return "badge-success";
    case "lost":
      return "badge-error";
    default:
      return "badge-ghost";
  }
};

/**
 * @param {string} stage pipeline stage value
 * @return {string} display label
 */
export const getStageLabel = (stage: string): string => {
  switch (stage) {
    case "preparation":
      return "提案準備";
    case "proposed":
      return "提案済";
    case "doc_screening":
      return "書類通過";
    case "interview":
      return "面談中";
    case "offer":
      return "内定";
    case "won":
      return "成約";
    case "lost":
      return "見送り";
    default:
      return stage;
  }
};
